<template>
  <div class="install" :class="{'installAdd': continues}">
    <div class="exist" v-if="!continues">
      <div class="head yp-topbar" id="head">
        <!--<input type="file">-->
        <ul class="clearfix">
          <li class="left" @click="back">返回</li>
          <li>设置共享人员</li>
        </ul>
      </div>
      <div class="tip">
        <ul>
          <li :class="{'active':flag===1}" @click="Count(1)">{{viewer}}</li>
          <li :class="{'active':flag===2}" @click="Count(2)">{{uploader}}</li>
          <li :class="{'active':flag===3}" @click="Count(3)">{{compiler}}</li>
        </ul>
      </div>
      <div class="search">
        <!--<input type="text" placeholder="搜索" v-model="txt">-->
        <span @click="add(flag)">继续添加</span>
      </div>
      <div class="content">
        <ul class="ulBox" v-on:scroll="scroll()" ref="ulBox">
          <li v-for="(item,index) in dataList">
            <div class="list">

              <!--<em class="check" ref="adminBox" @click="checked(index)" :fileId="item.id"></em>-->
              <img :src="item.avator" alt="" class="avatar">
              <span class="nickName" v-if="item.realName!==''">{{item.realName}}</span>
              <span v-else>{{item.account}}</span>
              <span v-if="item.isManager === 0" class="tipManager">创建者</span>
              <span class="close" @click="remove(item.id)" v-if="!(flag===3&&index===0)"></span>
              <span class="tel" :class="{'mr':flag===3&&index===0}">{{item.phoneNumber}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <mt-actionsheet
      :actions="delmember"
      v-model="delmembersModel" class="del">
    </mt-actionsheet>
  </div>
</template>
<script>
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import $ from 'jquery'

  export default {
    name: 'install',
    components: {},
    created () {
      this.flag = this.configFlag || 1
      this.load()
      this.userCount()
    },
    data () {
      return {
        continues: false,
        uploader: '可上传(0)',
        compiler: '可编辑(0)',
        viewer: '可查看(0)',
        dataList: [],
        addList: [],
        flag: 1,
        page: 0,
        txt: '',
        managerFileIds: '',
        readFileIds: '',
        editFileIds: '',
        checkMum: 0,
        delmembersModel: false,
        delmember: [{
          name: '确认删除',
          method: this.tworemove
        }],
        whenId: ''
      }
    },
    props: ['fileId', 'configFlag'],
    methods: {
      back: function () {
        this.$emit('child', false)
      },
//      添加之后刷新数据
      onload: function (type, userId) {
        let _this = this
        let permissionType = type
        let userIds = userId
        let checkbox = _this.$refs.adminBox
        apis.request(cloudApi.addUser, {fileId: _this.fileId, permissionType, userIds}).then(function (res) {
          _this.continues = false
          _this.userCount()
          for (let i = 0; i < checkbox.length; i++) {
            checkbox[i].setAttribute('class', 'check')
          }
          _this.dataList = []
          apis.request(cloudApi.userList, {page: 0, size: 20, fileId: _this.fileId, permissionType}).then(response => {
            let data = response.data.content
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.dataList.push(data[i])
              }
            }
          }).catch(function (error) {
          })
        })
      },
//      移除之后刷新数据
      offload: function (type) {
        let _this = this
        let permissionType = type
        _this.dataList = []
        apis.request(cloudApi.userList, {page: 0, size: 20, fileId: _this.fileId, permissionType}).then(response => {
          let data = response.data.content
          _this.userCount()
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.dataList.push(data[i])
            }
          }
        }).catch(function (error) {
        })
      },
//      搜索
      search: function () {
        let _this = this
        let addBox = _this.$refs.addBox
        addBox.scrollTop = 0
        _this.addList = []
        _this.page = 0
        apis.request(cloudApi.allUser, {info: this.txt, page: 0, size: 20}).then(function (res) {
          let data = res.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.addList.push(data[i])
            }
          }
        })
      },
//      取消添加成员
      close: function () {
        let _this = this
        _this.continues = false
      },
//      添加成员
      add: function (val) {
        this.$emit('add', val, this.dataList)
        this.continues = true
      },
//      移除成员
      remove: function (id) {
        this.whenId = id
        this.delmembersModel = true
      },
      tworemove: function () {
        let _this = this
        let userIds = this.whenId
        apis.request(cloudApi.removeUser, {fileId: _this.fileId, userIds}).then(function (res) {
          _this.offload(_this.flag)
        })
      },
      Count: function (index) {
        let _this = this
        _this.flag = index
        _this.dataList = []
        apis.request(cloudApi.userList, {
          page: 0,
          size: 20,
          fileId: _this.fileId,
          permissionType: index
        }).then(response => {
          let data = response.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.dataList.push(data[i])
            }
          }
        }).catch(function (error) {
        })
      },
//      设置头像
      avatarSrc: function (src) {
        if (src === '') {
          return '../../assets/images/defaultPic.png'
        } else {
          return src
        }
      },
//      加载数据
      load: function () {
        let _this = this
        console.log(1111111111111111)
        apis.request(cloudApi.userList, {page: 0, size: 20, fileId: _this.fileId, permissionType: this.flag}).then(response => {
          let data = response.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.dataList.push(data[i])
            }
          }
        }).catch(function (error) {
        })
      },
      scroll: function () {
        let _this = this
        let ulBox = _this.$refs.ulBox
        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
          _this.page++
          apis.request(cloudApi.userList, {
            page: _this.page,
            size: 20,
            fileId: _this.fileId,
            permissionType: 3
          }).then(response => {
            let data = response.data.content
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.dataList.push(data[i])
              }
            }
          }).catch(function (error) {
          })
        }
      },
      scrollAdd: function () {
        let _this = this
        let ulBox = _this.$refs.addBox
        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
          _this.page++
          apis.request(cloudApi.allUser, {page: _this.page, size: 20}).then(function (res) {
            let data = res.data.content
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.addList.push(data[i])
              }
            }
          })
        }
      },
//      各权限数量
      userCount: function () {
        let _this = this
        apis.request(cloudApi.userCount, {fileId: _this.fileId}).then(function (res) {
          let data = res.data
          console.dir(data)
          if (data.uploadCount >= 0) {
            _this.uploader = '可上传(' + data.uploadCount + ')'
          }
          if (data.readCount >= 0) {
            _this.viewer = '可查看(' + data.readCount + ')'
          }
          if (data.editCount >= 0) {
            _this.compiler = '可编辑(' + data.editCount + ')'
          }
        })
      },
      //      单个文件选中
      checked: function (index) {
        let _this = this
        let num = _this.$refs.adminBox[index].className.indexOf('checked')
        let checkbox = _this.$refs.adminBox
        if (num === -1) {
          let className = _this.$refs.adminBox[index].getAttribute('class')
          checkbox[index].setAttribute('class', className + ' ' + 'checked')
        } else {
          checkbox[index].setAttribute('class', 'check')
        }
        this.checkMum = $('.checked').length - 1
      },
      //      确定添加
      addEnd: function () {
        let _this = this
        let arr = ''
        let checkbox = _this.$refs.adminBox
        for (let i = 0; i < checkbox.length; i++) {
          if (checkbox[i].className.indexOf('checked') !== -1) {
            arr += checkbox[i].getAttribute('fileId') + ','
          }
        }
        arr = arr.substring(0, arr.length - 1)
        _this.managerFileIds = arr
        let userIds = _this.managerFileIds
        _this.onload(_this.flag, userIds)
      }
    }
  }
</script>
<style scoped>
  .oglistType {
    width: 100%;
    height: 1.76rem;
  }

  .tipManager {
    background: #F7F7FA;
    border: 1px solid #DBDBDB;
    border-radius: 8px;
    height: .44rem;
    line-height: .44rem;
    width: 1.04rem;
    text-align: center;
    margin-left: .32rem;
    font-family: PingFangSC-Regular;
    font-size: .24rem;
    color: #666666;
  }

  .oglistType > div {
    font-family: PingFangSC-Regular;
    font-size: .28rem;
    color: #000000;
    height: .87rem;
    line-height: .87rem;
    letter-spacing: 0;
    font-weight: bold;
  }

  .footer {
    background: #fff;
    width: 100%;
    border-top: 1px solid #F5F5F5;
    padding: 0 .24rem;
    line-height: .98rem;
    height: .98rem;
    position: fixed;
    bottom: 0;
  }

  .footer button {
    background: #E4393C;
    width: 2.62rem;
    margin-top: 0.09rem;
    height: .8rem;
    color: #fff;
    border: none;
    float: right;
    font-size: .36rem;
    border-radius: 10px;
  }

  .contentTitle {
    height: .76rem;
    line-height: .76rem;
    padding-left: .24rem;
    border-bottom: 1px solid #F1F1F1;
    width: 100%;
    color: #999999;
  }

  .footer .footerTip {
    font-size: .26rem;
    color: #E4393C;
  }

  /*顶部样式*/
  .head {
    font-size: 0.36rem !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.28rem;
    line-height: 0.88rem;
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    color: #fff;
    z-index: 999;
    padding: 0 0.3rem;
  }

  .head ul {
    text-align: center;
    position: relative;
    margin-top: 0.4rem;
  }

  .left {
    position: absolute;
    left: 0;
    font-size: 0.28rem;
  }

  .right {
    position: absolute;
    font-size: 0.28rem;
    right: 0;
    top: 0;
  }

  .tip ul {
    height: 0.89rem;
    background-color: #fff;
    line-height: 0.89rem;
    font-size: 0.28rem;
    color: #1c1f22;
    border-bottom: 1px solid #e5e5e5;
  }

  .tip ul li {
    width: 33.333%;
    float: left;
    text-align: center;
    opacity: 0.5;
  }

  .search {
    height: .88rem;
    line-height: .88rem;
    background-color: #F7F7FA;
    padding: 0 0.16rem;
    font-size: 0.28rem;
  }

  .search input {
    width: 7.18rem;
    height: 0.56rem;
    display: inline-block;
    padding-left: 0.54rem;
    font-size: 0.24rem;
    border: 1px solid #e5e5e5;
    border-radius: .1rem;
  }

  .search span {
    width: 6.9rem;
    height: 0.64rem;
    border-radius: 0.1rem;
    background-color: #E4393C;
    display: inline-block;
    float: right;
    margin-top: 0.23rem;
    color: #ffffff;
    text-align: center;
    line-height: 0.64rem;
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    /*float: left;*/
    margin-top: 0.13rem;
    vertical-align: sub;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  .content {
    height: 100%;
  }

  .install {
    height: 100%;
    background-color: #fff;
    padding-bottom: 2rem;
    /*padding-top: 1.28rem;*/
  }

  /*有内容时的样式*/
  .ulBox {
    height: 100%;
    overflow-y: scroll;
    width: 100%;
    padding-bottom: 3.5rem;
    background-color: #fff;
  }

  .ulBox li {
    border-bottom: 1px solid #e5e5e5;
    text-align: left;
    position: relative;
    padding: 0 0.3rem;
  }

  .ulBox li div:first-of-type {
    box-sizing: border-box;
  }

  .ulBox .list {
    height: 1.1rem;
    /*padding-top: 0.2rem;*/
    line-height: 1.1rem;
  }

  .ulBox li img {
    /*float: left;*/
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
  }

  .avatar {
    width: 0.64rem;
    height: 0.64rem;
    margin-right: 0.24rem;
    background-size: 100% 100%;
    border-radius: 50%;
    background-image: url('../../assets/images/defaultPic.png');
    background-repeat: no-repeat;
  }

  .con {
    display: inline-block;
    line-height: initial;
  }

  .tel {
    float: right;
  }

  .content span {
    display: inline-block;
  }

  .active {
    color: #E4393C;
    opacity: 1 !important;
    border-bottom: 2px solid #E4393C;
  }

  .continue {
    height: 100%;
  }

  .installAdd {
    padding-bottom: 1.1rem;
  }

  .close {
    float: right;
    background: url("../../assets/images/close.png") center no-repeat;
    background-size: 0.2rem 0.2rem;
    width: 0.2rem;
    height: 1.1rem;
    margin-left: 0.5rem;
  }

  .mr {
    margin-right: 0.7rem;
  }
</style>




// WEBPACK FOOTER //
// src/views/shareFile/install.vue